import { useBlockBrowserClose } from '@/hooks/useBlockBrowserClose';
import usePageTitle from '@/hooks/usePageTitle';
import { useCreateAvatarStore } from '@/pages/avatar/common/context';
import { AvatarCreateTab } from '@/pages/avatar/common/types';
import { ConsentStep, FootageStep, InstructionStep, WaitForUploadsStep } from '@/pages/avatar/components';
import { Header } from '@/pages/avatar/PremiumPlusCreatePage/components';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { handleConsentStatusUpdate } from '../common/handlers';
import { useConsentNotifications } from '../hooks';

const Container = styled.div`
    background-color: white;
    display: flex;
    flex-direction: column;
    height: 100%;
    max-width: 100vw;
`;

const TITLE = 'Create Avatar - D-ID';

const INSTRUCTIONS_FILE_LINK =
    'https://d-id-public-bucket.s3.us-west-2.amazonaws.com/StudioApp/public-assets/avatars/dvp/Premium_plus_Instructions2.pdf';

export const AvatarPage = observer(() => {
    const createAvatarStore = useCreateAvatarStore();
    useBlockBrowserClose(() => createAvatarStore.isDirty);
    usePageTitle(TITLE);

    useConsentNotifications(handleConsentStatusUpdate(createAvatarStore.updateSelectedConsent));

    return (
        <Container>
            <Header />
            {createAvatarStore.tab === AvatarCreateTab.INSTRUCTIONS && <InstructionStep instructionsFileLink={INSTRUCTIONS_FILE_LINK} />}
            {createAvatarStore.tab === AvatarCreateTab.FOOTAGE && <FootageStep shouldExtendInstruction={true} />}
            {createAvatarStore.tab === AvatarCreateTab.CONSENT && <ConsentStep />}
            {createAvatarStore.tab === AvatarCreateTab.WAIT_FOR_UPLOADS && <WaitForUploadsStep />}
        </Container>
    );
});
